import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { RequestWithdrowal } from '../../apis/api/DirectoryApi';
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const WithdrawalForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const dispatch = useDispatch();
  const company_id = Cookies.get("company_id");

  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      company_id,
    };

    console.log("Submitted Data:", updatedData);

    const response = await dispatch(RequestWithdrowal(updatedData));

    if (response?.payload?.status === "success") {
      toast.success("Withdrawal request submitted successfully.");
      reset();
    } else {
      toast.error(response?.payload?.message || "Something went wrong.");
    }
  };

  return (
    <div className="card mt-1">
      <div className="card-header fw-bold">
        Send Withdrawal Request to Admin
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">
                Amount <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                placeholder="Enter Amount"
                className={`form-control ${errors.amount ? 'is-invalid' : ''}`}
                {...register("amount", {
                  required: "Amount is required",
                  min: { value: 1, message: "Amount must be at least 1" }
                })}
              />
              {errors.amount && (
                <div className="invalid-feedback">{errors.amount.message}</div>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <input
                type="password"
                autoComplete="new-password"
                className={`form-control ${errors.pay_password ? 'is-invalid' : ''}`}
                placeholder="Enter Password"
                {...register("pay_password", {
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be at least 6 characters"
                  }
                })}
              />
              {errors.pay_password && (
                <div className="invalid-feedback">{errors.pay_password.message}</div>
              )}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">
              Comment <span className="text-danger">*</span>
            </label>
            <textarea
              rows="3"
              placeholder="Comment"
              className={`form-control ${errors.comment ? 'is-invalid' : ''}`}
              {...register("comment", {
                required: "Comment is required",
                minLength: {
                  value: 5,
                  message: "Comment must be at least 5 characters"
                }
              })}
            ></textarea>
            {errors.comment && (
              <div className="invalid-feedback">{errors.comment.message}</div>
            )}
          </div>

          <div className="text-end">
            <button type="submit" className="btn btn-primary">
              ✔ Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WithdrawalForm;
